import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
// import QrReader from "react-qr-reader";
import { Scanner, useDevices } from "@yudiel/react-qr-scanner";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { CRYPTO_SECRET_KEY } from "src/_config";
import { useParams } from "react-router";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

interface QrscannerModalProps {
  onClose: () => void;
  shouldShow: boolean;
  taskDetails: Record<string, unknown>;
  openSuccessFailureModal: (data: { type: string; point?: number; message?: string }) => void;
}

export default function QrscannerModal({
  onClose,
  shouldShow,
  taskDetails,
  openSuccessFailureModal,
}: QrscannerModalProps) {
  // const [selected, setSelected] = useState("environment");
  const [showScanner, setShowScanner] = useState<boolean>(true);
  const [showCamera, setShowCamera] = useState<boolean>(false);
  const deviceInfo = useDevices();
  const toast = useToaster();
  const eventApi = useEventApi();
  const { eventId, performanceId } = useParams<{ eventId?: string; performanceId?: string }>();
  const guestUserId = useAppGuestUserIdSelector();
  const userAction = useAppUserAction();
  const userDetails = useAppUserDetailsSelector();
  const eventAction = useAppEventAction();
  const [scannedData, setScannedData] = useState<string | null>(null);
  const [hasScanned, setHasScanned] = useState<boolean>(false);

  const handleScan = (scanData: Array<{ rawValue?: string }>) => {
    if (hasScanned) return;
    if (scanData[0]?.rawValue) {
      setHasScanned(true);
      setScannedData(scanData[0]?.rawValue);
      if (taskDetails?.is_upload_image == 1) {
        openCamera(scanData[0]?.rawValue);
        return;
      } else {
        submitScannedData(scanData[0]?.rawValue);
      }
    }
  };

  const submitScannedData = (scanData: string, photo?: { files?: FileList | File[] | null }) => {
    const formData = new FormData();
    // let params: any = {
    //   rodeo_event_id: parseInt(cryptr.decrypt(eventId)),
    //   performance_id: parseInt(cryptr.decrypt(performanceId)),
    //   task_id: taskDetails?.id,
    //   qr_code: scannedData,
    // };
    formData.append("rodeo_event_id", String(parseInt(cryptr.decrypt(eventId))));
    formData.append("performance_id", String(parseInt(cryptr.decrypt(performanceId))));
    formData.append("task_id", String(taskDetails?.id ?? ""));
    formData.append("qr_code", scanData);
    if (!userDetails) {
      if (guestUserId) {
        // params["guest_user_id"] = guestUserId;
        formData.append("guest_user_id", guestUserId);
      }
    }
    if (photo && photo.files && photo.files.length != 0) {
      // let contentType = photo.substring(photo.indexOf(":") + 1, photo.indexOf(";"));
      // let b64data = photo.substring(photo.indexOf(",") + 1);
      // let blob = b64toBlob(b64data, contentType);
      // formData.append("image", blob);
      const file = Array.isArray(photo.files) ? photo.files[0] : photo.files.item(0);
      if (file) {
        formData.append("image", file);
      }
      // params["image"] = photo;
    }
    eventApi.callScanQRCode(
      formData,
      (message: string, resp: unknown) => {
        if (resp && typeof resp === "object") {
          const respData = resp as { guest_user_id?: string; point?: number };
          console.log({ resp });
          if (respData.guest_user_id) {
            userAction.guestUserId(respData.guest_user_id);
          }
          if (respData.guest_user_id) {
            localStorage.setItem("guestUserId", respData.guest_user_id);
          } else {
            localStorage.removeItem("guestUserId");
          }
          eventAction.updateTaskListScanCount(taskDetails);
          openSuccessFailureModal({
            message: "You have earned " + (respData.point || 0) + " points",
            type: "success",
            point: respData.point,
          });
        }
        onClose();
        // setStartScan(false);
        toast.success(message);
      },
      (message: string) => {
        openSuccessFailureModal({ message: message, type: "fail" });
        onClose();
        toast.error(message);
      },
    );
  };

  const openCamera = (scannedData: string) => {
    const x = scannedData.split("##");
    if (
      x?.length != 3 ||
      taskDetails?.unique_code != x[0] ||
      taskDetails?.performance_id != x[1] ||
      taskDetails?.rodeo_event_id != x[2]
    ) {
      openSuccessFailureModal({
        message: "Ensure QR Code first, current QR Code not belongs to this task.",
        type: "fail",
      });
      onClose();
      return;
    }
    setShowCamera(true);
    setShowScanner(false);
  };

  useEffect(() => {
    setHasScanned(false); // Reset scan lock when modal is opened
  }, [shouldShow]);

  useEffect(() => {
    console.log(deviceInfo);
  }, [deviceInfo]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal modal-bg-white"
        size="lg"
      >
        <Modal.Header>
          <h2 className="modal-header-text">{String((taskDetails as { title?: string })?.title ?? "")}</h2>
          <button type="button" className="btn-close" onClick={() => onClose()}></button>
        </Modal.Header>
        <Modal.Body bsPrefix={"main-container"}>
          <div
            className="modal-body"
            // style={{ height: showCamera ? "80vh" : "100%" }}
          >
            {showScanner && <Scanner onScan={(result: Array<{ rawValue?: string }>) => handleScan(result)} />}
            {showCamera && (
              <>
                {/* <Camera
                  ref={camera}
                  numberOfCamerasCallback={setNumberOfCameras}
                  errorMessages={{
                    noCameraAccessible:
                      "No camera device accessible. Please connect your camera or try a different browser.",
                    permissionDenied: "Permission denied. Please refresh and give camera permission.",
                    switchCamera:
                      "It is not possible to switch camera to different one because there is only one video device accessible.",
                    canvas: "Canvas is not supported.",
                  }}
                />
                <button
                  style={{ position: "absolute", zIndex: "999" }}
                  onClick={() => {
                    const photo = camera.current.takePhoto();
                    console.log({ photo });
                    setImage(photo);
                    // setShowCamera(false);
                    // onClose();
                    submitScannedData(scannedData, photo);
                  }}
                >
                  Click
                </button>
                <button
                  hidden={numberOfCameras <= 1}
                  style={{ position: "absolute", zIndex: "999" }}
                  onClick={() => {
                    camera.current.switchCamera();
                  }}
                >
                  Switch
                </button> */}
                {/* <Webcam
                  audio={false}
                  height={720}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={1280}
                  videoConstraints={videoConstraints}
                />
                <button onClick={capture}>Capture photo</button> */}
                <div className="align-items-center d-flex flex-column gap-3 justify-content-center">
                  <img src="/images/check-circle.svg" width={"64"} alt="checkmark" />
                  <h3 className="mb-0">Scan Completed Successfully</h3>
                </div>
                <div className="upload-box">
                  <div className="upload-btn-wrapper">
                    <img src="/images/smartphone.png" width="80" alt="selfie" />
                    <button className="btn-upload">Click here to upload your selfie</button>
                    <input
                      accept="image/*"
                      id="icon-button-file"
                      type="file"
                      name="myfile"
                      // capture="environment"
                      capture="user"
                      onChange={(e) =>
                        submitScannedData(scannedData ?? "", {
                          files: e.target.files ? Array.from(e.target.files) : undefined,
                        })
                      }
                    />
                  </div>
                </div>
              </>
            )}
            {/* {image && <img src={image} alt="Image preview" width={"100%"} />} */}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <div className="btn-wrap mb-3 ">
            <button
              type="button"
              className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3"
              onClick={() => onClose()}
            >
              Close
            </button>
          </div>
        </Modal.Footer> */}
        {/* <div className="modal-footer d-block">
          <Sponsor />
        </div> */}
      </Modal>
    </React.Fragment>
  );
}
